import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ContractService } from '../../service/contract/contract.service';
import { Contract } from '../../class/contract';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, SelectItem, ToggleButtonModule } from 'primeng/primeng';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Candidate } from '../../class/candidate';
import { CandidateService } from '../../service/candidate/candidate.service';
import { config } from '../../../../../environments/config';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { values } from 'lodash';
import { DocumentProfileSurveyService } from '../../service/document-profile-survey/document-profile-survey.service'
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public msgs: Message[] = [];
    public contracts: Contract[];
    public selectContract: Contract;
    public selectContractType: string;
    public contract_status: any;
    public contractID: number = 0;
    public modNew = false;
    public modView = false;
    public openContract = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public selectCandidate: Candidate;
    public modViewDialogCandidate: boolean;
    public candidate: Candidate[];
    public sticky: boolean;

    public form2: FormGroup;
    public f2_date_good_standing: AbstractControl;
    public good_standing_tmp: string;

    public form3: FormGroup;
    public candidate_id_filter: AbstractControl;
    public company_id_filter: AbstractControl;
    public start_contract_filter: AbstractControl;
    public end_contract_filter: AbstractControl;
    public start_retired_filter: AbstractControl;
    public end_retired_filter: AbstractControl;
    public profile_survey_id_filter: AbstractControl;
    public first = 0;
    public filters: any[];

    public modExportDialog: boolean;

    public statusOptions: SelectItem[];

    public statusDocuOptions: SelectItem[];

    public ReportTypeExportOptions: SelectItem[];
    public selectedReportTypeExportOptions: { label: string, value: string };

    public form4: FormGroup;

    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_status_filter: AbstractControl;
    public f4_export_type_filter: AbstractControl;

    public modDownDocumentDialog: boolean;

    public ReportTypeDocumentOptions: SelectItem[];
    public selectedReportTypeDocumentOptions: { label: string, value: string };

    public form5: FormGroup;

    public f5_document_type_filter: AbstractControl;
    public f5_company_id: AbstractControl;
    public f5_status_filter: AbstractControl;


    public reloadInterval: any;

    public modViewDialogDocumentation: boolean;
    public modViewDialogTypeRetirement: boolean;
    public save_exit: boolean;
    public modgoodStandingDialog: boolean;
    public result: any;

    public per_page_documentation: number;

    public apiUrl = config.API_ROOT;

    public uploadedAttachment: any[] = [];
    public prewiewFileAttachment: any;
    public promiseAttachment: Promise<any>;
    public type_retirement: AbstractControl;
    public finish_contract_observation: AbstractControl;
    public candidate_email: AbstractControl;
    public send_to_worker_mail: AbstractControl;
    public exclusion_candidate: AbstractControl;
    public end_contract: AbstractControl;

    public candidate_name: any;
    public candidate_dni: any;

    public optionsTypeRetirement: any[];
    public listDocuments: any[] = [];
    public es: any;
    public loading_upload: boolean;

    public exclusionTerminationOfContract: boolean = false;
    public nameExclusionTerminationOfContract: string = 'exclusion_termination_of_contract';

    constructor(
        public contractService: ContractService,
        public confirmationService: ConfirmationService,
        public candidateService: CandidateService,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public documentProfileSurveyService: DocumentProfileSurveyService,


        fb: FormBuilder) {

        this.form = fb.group({
            'type_retirement': ['', Validators.compose([Validators.required])],
            'finish_contract_observation': [''],
            'candidate_email': ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])],
            'send_to_worker_mail': [true, Validators.compose([Validators.required])],
            'exclusion_candidate': [false, Validators.compose([Validators.required])],
            'end_contract': ['', Validators.compose([Validators.required])]
        });
        this.type_retirement = this.form.controls['type_retirement'];
        this.end_contract = this.form.controls['end_contract'];
        this.finish_contract_observation = this.form.controls['finish_contract_observation'];
        this.candidate_email = this.form.controls['candidate_email'];
        this.send_to_worker_mail = this.form.controls['send_to_worker_mail'];
        this.exclusion_candidate = this.form.controls['exclusion_candidate'];

        this.form2 = fb.group({
            'f2_date_good_standing': ['', Validators.compose([Validators.required])],
        });
        this.f2_date_good_standing = this.form2.controls['f2_date_good_standing'];

        this.form3 = fb.group({
            'candidate_id_filter': [''],
            'company_id_filter': [''],
            'start_contract_filter': [''],
            'end_contract_filter': [''],
            'start_retired_filter': [''],
            'profile_survey_id_filter': [''],
            'end_retired_filter': [''],
            'status_id_filter': [''],
        });

        this.listDocuments = [];

        this.modViewDialogCandidate = false;
        this.modViewDialogDocumentation = false;
        this.modViewDialogTypeRetirement = false;
        this.save_exit = false;
        this.sticky = false;

        this.optionsTypeRetirement = [];
        this.optionsTypeRetirement.push({ label: 'Terminación obra', value: 'Terminación Obra' });
        this.optionsTypeRetirement.push({ label: 'Terminación mutuo acuerdo', value: 'terminación Mutuo Acuerdo' });
        this.optionsTypeRetirement.push({ label: 'Renuncia', value: 'Renuncia' });
        this.optionsTypeRetirement.push({ label: 'Inejecución', value: 'Inejecución' });
        this.optionsTypeRetirement.push({ label: 'Inexistencia', value: 'Inexistencia' });

        this.form4 = fb.group({
            'f4_date_start': ['', [Validators.required]],
            'f4_date_end': ['', [Validators.required]],
            'f4_status_filter': [''],
            'f4_export_type_filter': ['', [Validators.required]],
        });

        this.f4_date_start = this.form4.controls['f4_date_start'];
        this.f4_date_end = this.form4.controls['f4_date_end'];
        this.f4_status_filter = this.form4.controls['f4_status_filter'];
        this.f4_export_type_filter = this.form4.controls['f4_export_type_filter'];

        this.f4_status_filter.setValue('');
        this.modExportDialog = false;

        this.statusOptions = [
            { label: 'Todos los estados', value: '' },
            { label: 'Activo', value: '1' },
            { label: 'Retirado', value: '2' },
            { label: 'Pendiente por inejecutar', value: '3' },
            { label: 'Injecución aprobada por jurídica', value: '4' },
            { label: 'Inejecutado', value: '5' }
        ];

        this.ReportTypeExportOptions = [
            { label: 'Reporte General', value: 'Reporte General' },
            { label: 'Reporte Citación - Documentación', value: 'Reporte Citación - Documentación' },
            { label: 'Reporte Citación - Documentación Retirados', value: 'Reporte Citación - Documentación Retirados' },
        ];

        this.form5 = fb.group({
            'f5_document_type_filter': ['', [Validators.required]],
            'f5_company_id': ['', [Validators.required]],
            'f5_status_filter': [''],
        });

        this.f5_document_type_filter = this.form5.controls['f5_document_type_filter'];
        this.f5_company_id = this.form5.controls['f5_company_id'];
        this.f5_status_filter = this.form5.controls['f5_status_filter'];

        this.f5_status_filter.setValue('');
        this.modDownDocumentDialog = false;

        this.statusDocuOptions = [
            { label: 'Todos', value: '' },
            { label: 'Activos', value: '1' },
            { label: 'Retirado', value: '2' },
        ];

        this.ReportTypeDocumentOptions = [
            { label: 'Hoja de Vida', value: '1' },
            { label: 'Cédula de Ciudadanía', value: '2' },
            { label: 'Certificación EPS', value: '3' },
            { label: 'Examen medico', value: '4' },
            { label: 'Contrato Digital', value: '33' },

        ];

        this.es = calendarES();
        this.good_standing_tmp = '0';
        this.modgoodStandingDialog = false;
        this.loading_upload = false;
    }

    ngOnInit() {
        //this.getContracts();
        this.page = 1;
        this.per_page = 10;

        this.per_page_documentation = 100;
        this.form.get('exclusion_candidate').valueChanges.subscribe(value => {
            this.exclusionTerminationOfContract = this.observerValueExclusionCandidate(value, 'termination_of_contract');
        });

    }

    public loadContractsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort = '-' + event.sortField;
        } else {
            this.sort = event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.getContracts(event.globalFilter);

    }

    public getContracts(query?: string) {
        this.contractService.getContract(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.contracts = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'error' });
            }
        );

    }

    getCandidate(query?: string) {
        this.candidateService.getCandidate(this.page, this.per_page, undefined, query).toPromise().then(
            response => {
                this.candidate = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'error' });
            }
        );
    }

    public newContract() {
        this.modNew = !this.modNew;
        this.selectContract = null;
        this.selectContractType = null;
    }

    public savedContract(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectContract = null;
        this.selectContractType = null;
        this.modNew = false;
        this.getContracts();
    }

    public cancelContract(res) {
        this.selectContract = null;
        this.selectContractType = null;
        this.modNew = false;
        this.modView = false;
        this.getContracts();
    }

    public edit(contract: Contract) {
        this.modNew = true;
        this.selectContract = contract;
        this.getContracts();
    }

    public view(contract: Contract) {
        this.openContract = true;
        this.selectContract = contract;
        this.contractID = contract.id;
        this.modView = true;
    }

    public deleteDialog(contract: Contract) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(contract);
            }
        });
    }

    public delete(contract: Contract) {
        this.contractService.deleteContract(contract.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'deleted' });
                this.getContracts();
            },
            error => {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'error' });
            }
        );
    }

    public changeStatusContract(contract: Contract, value?, candidate: Candidate = null) {
        this.selectContract = contract;
        this.selectContract.status_id = value;
        if (value == 2 || value == 5) //En caso de que sea inactivarlo o que se inejecute
        {
            this.modViewDialogTypeRetirement = true;

            // contract.status_id = value;
            this.contract_status = value;
            this.candidate_email.setValue(this.selectContract.candidate_email);

            this.candidate_name = this.selectContract.candidate_name;
            this.candidate_dni = this.selectContract.identification_number;
            // this.candidate_dni.setValue(this.selectContract.identification_number);
        }
        else
            this.putContract(this.selectContract);

    }

    public updateContract(value) {
        this.selectContract.type_retirement = value.type_retirement;
        this.selectContract.end_contract = value.end_contract;
        this.selectContract.finish_contract_observation = value.finish_contract_observation;
        this.selectContract.candidate_email = value.candidate_email;
        this.selectContract.send_to_worker_mail = value.send_to_worker_mail;
        if (value.exclusion_termination_of_contract)
            this.selectContract['exclusion_termination_of_contract'] = value.exclusion_termination_of_contract;
        if (this.contract_status === '1') {
            this.selectContract.end_contract = null;
            this.selectContract.date_of_completion_end_contract = null;
        }
        else
            this.selectContract.date_of_completion_end_contract = formatDate(new Date().toISOString());

        this.selectContract.status_id = this.contract_status;

        this.putContract(this.selectContract);

        // this.modViewDialogTypeRetirement = false;
    }

    public filter(values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];

        if (values.company_id_filter) {
            this.filters.push({ 'key': 'company_id-lk', 'value': values.company_id_filter.id });
        }


        if (values.candidate_id_filter) {
            this.filters.push({ 'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id });
        }


        if (values.profile_survey_id_filter) {
            this.filters.push({ 'key': 'profile_survey_id-lk', 'value': values.profile_survey_id_filter });
        }


        if (values.start_contract_filter && values.end_contract_filter) {
            let d = new Date(values.start_contract_filter);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);

            const start_contract_filter = formatDate(d);

            d = new Date(values.end_contract_filter);
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            d.setMilliseconds(59);
            const end_contract_filter = formatDate(d);

            if (start_contract_filter) {
                values.filters.push({ 'key': 'start_contract-min', 'value': start_contract_filter });
            }

            if (end_contract_filter) {
                values.filters.push({ 'key': 'start_contract-max', 'value': end_contract_filter });
            }

        }

        if (values.start_retired_filter && values.end_retired_filter) {
            let d = new Date(values.start_retired_filter);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);

            const start_retired_filter = formatDate(d);

            d = new Date(values.end_retired_filter);
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            d.setMilliseconds(59);
            const end_retired_filter = formatDate(d);

            if (start_retired_filter) {
                values.filters.push({ 'key': 'end_contract-min', 'value': start_retired_filter });
            }

            if (end_retired_filter) {
                values.filters.push({ 'key': 'end_contract-max', 'value': end_retired_filter });
            }

        }

        if (values.status_id_filter != '')
            this.filters.push({ 'key': 'status_id-lk', 'value': values.status_id_filter });

        this.getContracts();
    }

    public filterAllContractList() {
        this.selectContractType = undefined;
    }

    public filterContractContractList() {
        this.selectContractType = 'Contrato';
    }

    public filterRetireContractList() {
        this.selectContractType = 'Retiro';
    }

    public filterAll() {
        this.page = 1;
        this.first = 0;
        this.filter(true);
    }

    // public filterActivated() {
    //     this.filter(true);
    // }

    // public filterRetired() {
    //     this.filter(true);
    // }

    //   public viewDialogCandidate(candidate: Candidate, sticky: boolean) {
    //     this.selectCandidate = candidate;
    //     this.modViewDialogCandidate = true;
    //     this.sticky = sticky;
    //   }

    public viewDialogCandidate(id: number, sticky: boolean) {

        this.candidateService.infoCandidate(id).toPromise().then(
            response => {
                this.selectCandidate = response.json();
                this.modViewDialogCandidate = true;
                this.sticky = sticky;
            },
            error => {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'error' });
            }
        );

    }
    public viewHideDialogCandidate() {
        if (!this.sticky) {
            this.modViewDialogCandidate = false;
        }
    }

    public cancelCandidate(res) {
        this.selectCandidate = null;
        this.modViewDialogCandidate = false;
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
    public hasRole(rol) {
        var r: boolean = false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if (role == rol) {
            r = true;
        }
        return (r);
    }

    public putContract(values: Contract) {
        //   var param = {
        //     'status_id': values.status_id,
        //     'end_contract': values.end_contract,
        //     'type_retirement': values.type_retirement,
        //     'finish_contract_observation': values.finish_contract_observation,
        //     'candidate_email': values.candidate_email,
        //     'send_to_worker_mail': values.send_to_worker_mail,
        //   };
        //   if(values.good_standing_at){
        //     param['good_standing'] = values.good_standing;
        //     param['good_standing_at'] = values.good_standing_at;
        //     param['good_standing_by_id'] = values.good_standing_by_id;
        //   }
        if (values) {
            const promise = this.contractService.updateContract(values.id, values);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push({ severity: 'success', summary: res });

                        this.modViewDialogTypeRetirement = false;
                        this.modgoodStandingDialog = false;

                        this.getContracts();
                    });
                },
                error => {
                    this.msgs.push({ severity: 'error', summary: 'Error' });
                }
            );
        }


    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        var url = this.apiUrl + '/contracts/excel?type=' + values.f4_export_type_filter.value +
            '&token=' + localStorage.getItem('token') +
            '&_page=1&';

        if (values.f4_export_type_filter.value === 'Reporte Citación - Documentación') {
            url = this.apiUrl + '/citations/excel?' +
                'token=' + localStorage.getItem('token') +
                '&_page=1&_limit=100000&_sort=venue_id,company_id&';
            url = url + 'type=' + values.f4_export_type_filter.value + '&';
            if (f4_date_start) {
                url = url + 'admission_date-min=' + f4_date_start + '&';
            }

            if (f4_date_end) {
                url = url + 'admission_date-max=' + f4_date_end + '&';
            }
        }
        else {
            if (values.f4_status_filter == '2') // Retirados
            {
                if (f4_date_start)
                    url += 'end_contract-min=' + f4_date_start + '&';

                if (f4_date_end)
                    url += 'end_contract-max=' + f4_date_end + '&';

                url += 'status_id=2&';
            }
            else {
                if (f4_date_start)
                    url += 'created_at-min=' + f4_date_start + '&';

                if (f4_date_end)
                    url += 'created_at-max=' + f4_date_end + '&';

                if (values.f4_status_filter != '')
                    url += 'status_id=' + values.f4_status_filter + '&';
            }
            // url+='_with=citation.document_profile_survey';
        }
        window.open(url, '_blank');
    }

    public cancelExport() {
        this.modExportDialog = false;
    }
    public showDownDocumentDialog() {
        this.modDownDocumentDialog = true;
    }
    public DownDocumentZip(values) {
        var url = this.apiUrl

        if (values.f5_document_type_filter.value) {
            url = this.apiUrl + '/document-profile-surveis/zip' + '?token=' + localStorage.getItem('token') + '&'
                + 'document_type=' + values.f5_document_type_filter.value + '&company_id=' + values.f5_company_id.id
                + '&company_name=' + values.f5_company_id.name + '&document_name=' + values.f5_document_type_filter.label;
        }

        if (values.f5_status_filter != '') {
            // if (values.f5_status_filter.value == 'all') {

            // }
            if (values.f5_status_filter != '') {

                url += '&status_id=' + values.f5_status_filter;
            }
            //url+='_with=citation.document_profile_survey';
        }
        window.open(url, '_blank');

    }

    public cancelDownDocument() {
        this.modDownDocumentDialog = false;
    }

    //   public showDocumentationDialog(contract, type) {
    //     this.selectContract = contract;
    //     this.selectContractType = type;
    //     this.uploadedAttachment = [];
    //     this.listDocuments = [];

    //     this.selectContract.citation.document_profile_survey.forEach(element => {
    //         this.uploadedAttachment[element.checklist_profile_survey_id] = {'name': 'Archivo Adjunto  ', 'id': element.id};
    //     });

    //     this.selectContract.citation.profile_survey.checklist_profile_survey.forEach(element => {
    //         if (element.list_doc_profile_survey.type == type) {
    //             this.listDocuments.push(element);
    //         }
    //     });

    //     this.modViewDialogDocumentation = true;
    //   }


    public showDocumentationDialogContract(contract, type) {

        this.selectContract = contract;
        this.selectContractType = type;
        this.uploadedAttachment = [];
        // let DocumentProfileSurvey : any[];
        // let CheckListProfileSurvey : any[];
        var citation_id = contract.citation_id;
        var profile_survey_id = contract.profile_survey_id;

        //Promesa que combina DocumentProfileSurvey->  //Función que obtiene los documentos subidos para un contrato
        // y CheckList->Función que obtiene los documentos requeridos para un perfil de cargo

        this.contractService.getDocumentProfileSurveyUnionCheckList(citation_id, profile_survey_id, this.selectContractType).toPromise().then(response => {
            this.listDocuments = [];
            this.result = response.json();
            console.log('tipo : ' + typeof (this.result));
            let list = [...this.listDocuments];
            this.result.data.forEach(element => {
                if (element.document_profile_survey.length > 0) {
                    for (var x = 0; x < element.document_profile_survey.length; x++) {
                        if (element.document_profile_survey[x].expires_at) element.document_profile_survey[x].expires_at = new Date(element.document_profile_survey[x].expires_at);
                    }
                }
                if (element.type == type) {
                    list.push(element);
                }
            });
            this.listDocuments = list;
            this.modViewDialogDocumentation = true;
            this.loading_upload = false;
        },
            error => {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'error' });
            }

        );

        //Promesa de DocumentProfileSurvey -> documentos que se subieron por perfil de cargo
        // this.contractService.getDocumentProfileSurvey(citation_id).toPromise().then( //Función que obtiene los documentos subidos para un contrato
        //     response => {
        //         DocumentProfileSurvey = response.json();
        //         console.log(DocumentProfileSurvey);
        //         DocumentProfileSurvey.forEach(element => {
        //             this.uploadedAttachment[element.checklist_profile_survey_id] = {'name': 'Archivo Adjunto  ', 'id': element.id};
        //         });
        //     },
        //     error => {
        //         this.msgs = [];
        //         this.msgs.push( { severity: 'error', summary: 'error' } );
        //     }
        // );

        //Promesa de checklist ->documentos que necesita el perfil de cargo
        // this.contractService.getCheckListProfileSurvey(profile_survey_id).toPromise().then( //Función que obtiene los documentos requeridos para un perfil de cargo
        //     response => {
        //         CheckListProfileSurvey = response.json();
        //         console.log(CheckListProfileSurvey);
        //         CheckListProfileSurvey.forEach(element => {
        //             if (element.list_doc_profile_survey.type == type) {
        //                 this.listDocuments.push(element);
        //             }
        //         });
        //     },
        //     error => {
        //         this.msgs = [];
        //         this.msgs.push( { severity: 'error', summary: 'error' } );
        //     }
        // );

    }
    public onUploadFileDocumentProfileSurvey(event: any) {
        console.log(event);
    }

    //   public updateAttachmentDocumentProfileSurvey(event, contract, checklist_profile_survey) {
    //     this.translate.get('uploading').subscribe((res: string) => {
    //         this.notificationsService.growlNotify('info', res + '...');
    //     });

    //       let id;
    //       if (checklist_profile_survey.document_profile_survey) {
    //         if (checklist_profile_survey.document_profile_survey.length > 0) {
    //           id = checklist_profile_survey.document_profile_survey[0].id;
    //         }
    //       }

    //       this.uploadedAttachment = [];
    //       for (const file of event.files) {
    //           this.uploadedAttachment.push(file);
    //       }

    //       this.promiseAttachment = this.uploadFilesService.updateAttachmentDocumentProfileSurvey(this.uploadedAttachment, id, contract.citation.id, contract.citation.profile_survey_id, checklist_profile_survey.id, checklist_profile_survey.list_doc_profile_survey_id).toPromise().then(
    //           response => {
    //               this.translate.get('saved').subscribe((res: string) => {
    //                   this.notificationsService.growlNotify('success', res);
    //               });
    //           },
    //           error => {
    //               let msg = '';
    //               this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
    //                   this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
    //                       JSON.parse(error._body).errors.forEach(element => {
    //                           if (element.source) {
    //                               if (element.source.pointer) {
    //                                   this.translate.get(element.source.pointer).subscribe((res3: string) => {
    //                                       msg = msg + res3 + ', ';
    //                                   });
    //                               }
    //                           }
    //                       });
    //                       this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
    //                   });
    //               });
    //           }
    //       );
    //   }

    public updateAttachmentDocumentProfileSurvey(event, contract, checklist_profile_survey) {
        this.loading_upload = true;
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

        let id;
        if (checklist_profile_survey.document_profile_survey) {
            if (checklist_profile_survey.document_profile_survey.length > 0) {
                id = checklist_profile_survey.document_profile_survey[0].id;
            }
        }

        this.uploadedAttachment = [];
        for (const file of event.files) {
            this.uploadedAttachment.push(file);
        }

        this.promiseAttachment = this.uploadFilesService.updateAttachmentDocumentProfileSurvey(this.uploadedAttachment, id, contract.citation_id, contract.profile_survey_id, checklist_profile_survey.id, checklist_profile_survey.list_doc_profile_survey_id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                    this.showDocumentationDialogContract(this.selectContract, this.selectContractType);

                });

            },
            error => {
                this.loading_upload = false;
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );

    }

    public deleteAttachmentDocumentProfileSurvey(id) {
        this.promiseAttachment = this.uploadFilesService.deleteAttachmentDocumentProfileSurvey(id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
                delete this.uploadedAttachment[id];
                this.showDocumentationDialogContract(this.selectContract, this.selectContractType);
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public gotoAttachment(id) {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public gotoAttachmentDocumentProfileSurvey(id) {
        window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public downloadAllFiles(id) {
        window.open(this.apiUrl + '/document-profile-surveis/' + id + '/zip' + '?token=' + localStorage.getItem('token'), '_blank');
    }
    public goodStandingDialog(contract: Contract, value?) {
        this.modgoodStandingDialog = true;
        this.selectContract = contract;
        this.good_standing_tmp = value;// this.selectContract.good_standing = value;

    }
    public cancelgoodStandingDialog() {
        this.modgoodStandingDialog = false;
    }
    public goodStandingContract(values) {
        console.log(this.f2_date_good_standing.value);
        this.selectContract.good_standing = this.good_standing_tmp;
        if (this.selectContract.good_standing === '1') {
            // contract.good_standing_at = formatDate(new Date().toISOString());
            // contract.good_standing_at = this.f2_date_good_standing;
            if (this.f2_date_good_standing.status == 'VALID')
                this.selectContract.good_standing_at = formatDate(this.f2_date_good_standing.value);

        } else {
            this.selectContract.good_standing_at = null;
        }
        this.selectContract.good_standing_by_id = JSON.parse(localStorage.getItem('profile')).employee.id;

        // this.selectContract = contract;
        this.putContract(this.selectContract);
        // this.modgoodStandingDialog = false;
    }
    saveExpiresAt(item)//   saveExpiresAt(expires,doc_item_id,expire_at)
    {
        let item_t = item;
        item_t.expires_at = formatDate(item_t.expires_at.toISOString());
        var doc_item_id = item_t.id;
        console.log(item_t);
        this.promiseAttachment = this.documentProfileSurveyService.updateDocumentProfileSurvey(doc_item_id, item_t).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    observerValueExclusionCandidate(obj, name) {
        var variableForShowForm = false;
        // var name_edit = 'result_' + name;
        var name_form = 'exclusion_' + name;
        // Dependiendo del valor seleccionado, muestra u oculta el FormGroup adicional
        if (obj != null && obj != '') {
            if (obj == true) //.value
            {
                variableForShowForm = true;
            }
            else {
                variableForShowForm = false;
                if (this.form.get(name_form)) {
                    this.form.removeControl(name_form);
                }
            }
        }
        return variableForShowForm;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/contracts/contracts.component.ts